import Management from "../../components/Management";
function ManagementPage() {
  return (
    <div>
      <Management />
    </div>
  );
}

export default ManagementPage;
